define(function (require) {

    var _ = require('underscore');
    var lpUtils = require('utils/lpUtils');
    var webAgentStatics = require('web-agent-assets-js/lpWebAgentStatics');
    var WebAgentLogger = require('web-agent-assets-js/WebAgentLogger');
    var lpAgent = require('web-agent-assets-js/lpAgent');
    var lpAMSController = require('web-agent-assets-js/lpAMSController');
    var agentLEManager = require('web-agent-utils/agentLEManager');
    var privilegesController = require('web-agent-assets-js/lpPrivilegesController');
    var leConf = require("assets/config/le-conf");

    window.lpTag = window.lpTag || {};
    window.lpTag.taglets = window.lpTag.taglets || {};
    window.lpTag.WebAgent = window.lpTag.WebAgent || {};
    window.lpTag.AMSStatics = window.lpTag.AMSStatics || {};

    lpTag.lpLogicController = function (model, constructorData) {

        var logicController = {applicationType: "lpLogicController"};
        var logger = WebAgentLogger.getLogger(logicController.applicationType);

        if (constructorData) {
            logicController.logoutMethod = constructorData.logoutMethod;
            logicController.revalidateSession = constructorData.revalidateSession;
            if (constructorData.authError) {
                logicController.authErrorMethod = constructorData.authError.method;
                logicController.authErrorTypes = constructorData.authError.types;
            }
        }

        logicController.defaultChatsRootModelPath = 'chats';


        logicController.engagementTypes = {
            unknown: 'unknown',
            realTimeChat: 'realTimeChat',
            asyncMessaging: 'asyncMessaging'
        };
        logicController.participants = {};
        logicController.sentimentMap = {
            neutral: "neutral",
            positive: "positive",
            negative: "negative"
        };
        logicController.colorsScheme = ['blue', 'green', 'pink', 'cyan', 'violet', 'orange'];
        logicController.defaultColorScheme = 'orange'; // currently in use mainly for spectated engagements
        logicController.engagementStates = {
            active: "active",
            inactive: "inactive",
            completed: "completed"
        };
        logicController.chatStates = {
            chatting: "chatting",
            ended: "ended"
        };
        logicController.conversationStates = lpTag.AMSStatics.conversation.states;
        logicController.conversationCloseReasons = lpTag.AMSStatics.conversation.closeReasons;
        logicController.participantsRoles = lpTag.AMSStatics.participant.roles;
        logicController.dialogTypes = lpAMSController.DIALOG_TYPES;

        logicController.colorIndex = 0;

        logicController.connectionStates = {
            ACTIVE: 'active',
            DISABLED: 'disabled',
            NOTIFY: 'notify'
        };

        logicController.numOfActiveChats = 0;
        logicController.numOfActiveConversations = 0;
        logicController.maxChatsAllowed = 0;

        logicController.fetchRequestBufferTime = 30000;
        logicController.fetchRequestLatestTime = 0;

        logicController.ENGAGEMENT_CHANNELS = {
            CHAT: 'chat',
            COBROWSE: 'cobrowse'
        };

        logicController.AVAILABILITY_TYPES = {
            ONLINE: "ONLINE",
            AWAY: "AWAY",
            BACK_SOON: "BACK_SOON"
        };

        logicController.getModelParam = function (paramName) {
            return model.get(paramName);
        };

        logicController.bindModelParam = function (modelParam, func, scope, trigger) {
            model.bind(modelParam, func, scope, trigger);
        };

        logicController.unbindModelParam = function (key, callback, context) {
            model.unbind(key, callback, context);
        };

        logicController.diagnostics = {
            keys: {
                updateAMSAvailabilitySuccess: 'updateAMSAvailabilitySuccess',
                updateAMSAvailabilityNotConnected: 'updateAMSAvailabilityNotConnected',
                keepAliveDenverError: 'keepAliveDenverError',
                socketConnectionStateChangeUMS: 'socketConnectionStateChangeUMS'
            },
            isKeyActive: function (key) {
                var values = agentLEManager.getAccountSettingValueByIdLE('le.agent.diagnostics');
                return !!values && values.length > 0 && typeof values.indexOf === 'function' && values.indexOf(key) >= 0;
            }
        };

    logicController.getAgentGroupByAgentId = function (agentId) {
        var operator = logicController.getOperatorInfo(agentId);
        return operator && operator.agentGroupId;
    };

    /**
     * Get the agent group name of agent Id
     * @param id Agent Id
     * @returns {String}
     */
    logicController.getAgentGroupNameById = function(agentId) {
        var agentGroupName;
        if (agentId) {
            var agentGroupId = this.getAgentGroupByAgentId(agentId);
            // Get the agent groups list and find the group id in it.
            if (agentGroupId) {
                var agentGroups = logicController.getAgentGroupsById();
                if (agentGroups) {
                    agentGroupName = agentGroups[agentGroupId];
                }
            }
        }
        return agentGroupName;
    };

        logicController.getVisitorNameFromTranscript = function (name) {
            return name && name.toString().toLowerCase() == 'you' ? agentLEManager.translateLE('LEWebAgent.participantDefaultName') : name && name.toString();
        };

        logicController.isConversationStateLocked = function (conversationState) {
            return conversationState === logicController.conversationStates.LOCKED;
        };

        logicController.isUserLoggedInAgent = function (userId) {
            return userId === logicController.getModelParam('agent.messagingUserId');
        };

        logicController.hasViewAllChatsPrivilege = function () {
            // The privilege is 10.
            return !!agentLEManager.hasLEPrivilege(lpTag.WebAgent.privileges.privilegeIDs.VIEW_ALL_CHATS);
        };

        logicController.hasParticipatePrivilege = function () {
            // The privilege is 13 - join only.
            return !!agentLEManager.hasLEPrivilege(lpTag.WebAgent.privileges.privilegeIDs.PARTICIPATE_IN_CHATS);
        };

        // Need to be removed after profiles feature is turned on by default
        logicController.isMessagingHistoryEnabled = function () {
            if (logicController.hasMessagingFeature()) {
                var isCampaignManager = (privilegesController.hasCampaignManagerModulePrivilege() && !privilegesController.hasUsersViewPrivilege());
                var hasProfilesFeature = logicController.hasProfileFeature();
                var hasHistoryPrivilege = privilegesController.hasMessagingHistoryPrivilege();

                return ((hasProfilesFeature && hasHistoryPrivilege) || (!hasProfilesFeature && !isCampaignManager));
            }
            return false;
        };

        logicController.isLoggedInAgentReaderParticipant = function (chatId, dialogId, chatsRootModelPath) {
            chatsRootModelPath = getChatsRoomModelPath(chatsRootModelPath);
            var loggedInAgentRole = logicController.getLoggedInAgentRoleInConversationDialog(chatId, dialogId, chatsRootModelPath);
            return loggedInAgentRole === logicController.participantsRoles.READER;
        };

        logicController.isLoggedInAgentManagerParticipant = function (chatId, dialogId, chatsRootModelPath) {
            chatsRootModelPath = getChatsRoomModelPath(chatsRootModelPath);
            var loggedInAgentRole = logicController.getLoggedInAgentRoleInConversationDialog(chatId, dialogId, chatsRootModelPath);
            return loggedInAgentRole === logicController.participantsRoles.MANAGER;
        };

        logicController.getLoggedInAgentRoleInConversationDialog = function (chatId, dialogId, chatsRootModelPath) {
            var path = logicController.getLoggedInAgentRolePathInConversationDialog(chatId, dialogId, chatsRootModelPath);
            return logicController.getModelParam(path);
        };

        logicController.getLoggedInAgentRolePathInConversationDialog = function (chatId, dialogId, chatsRootModelPath) {
            chatsRootModelPath = getChatsRoomModelPath(chatsRootModelPath);
            var loggedInAgentId = logicController.getModelParam('agent.id');
            return chatsRootModelPath + '.' + chatId + '.chatInfo.dialogs.' + dialogId + '.participantsDetails.' + loggedInAgentId + '.role';
        };

        logicController.isParticipantSuggestedInConversation = function (convId, userId, chatsRootModelPath) {
            chatsRootModelPath = getChatsRoomModelPath(chatsRootModelPath);

            var suggestedParticipants = logicController.getModelParam(chatsRootModelPath + '.' + convId + '.chatInfo.dialogs.' + convId + '.suggestedParticipantsDetails');
            return suggestedParticipants && !!suggestedParticipants[userId];
        };

        logicController.getAssignedAgentInConversation = function (convId, chatsRootModelPath) {
            var participants = logicController.getActiveAndSuggestedParticipantsInConversation(convId, chatsRootModelPath);
            for (const participant in participants) {
                if (participants[participant].role === lpTag.AMSStatics.participant.roles.ASSIGNED_AGENT) {
                    return participants[participant];
                }
            }
        };

        logicController.getSuggestedAgentInfoInConversation = function (convId, chatsRootModelPath) {
            chatsRootModelPath = getChatsRoomModelPath(chatsRootModelPath);
            return logicController.getModelParam(chatsRootModelPath + '.' + convId + '.suggestedAgentInfo');
        };

        logicController.getParticipantInConversation = function (convId, userId, chatsRootModelPath) {
            var participantsInDialog = logicController.getActiveAndSuggestedParticipantsInConversation(convId, chatsRootModelPath);

            return participantsInDialog && participantsInDialog[userId];
        };

        // a limitation to this function is if an agent exists in both lists (i.e. both suggested assigned agent and a reader)
        // in that case, the suggestedParticipantsDetails will override the participantsDetails
        logicController.getActiveAndSuggestedParticipantsInConversation = function (convId, chatsRootModelPath) {
            chatsRootModelPath = getChatsRoomModelPath(chatsRootModelPath);
            var mainDialog = logicController.getMainDialogOfConversation(convId, chatsRootModelPath);
            if (mainDialog) {
                return _.assign({}, mainDialog.participantsDetails, mainDialog.suggestedParticipantsDetails);
            }
        };

        logicController.isInMyEngagements = function (chatId) {
            var myEngagementsChatPath = logicController.getMyEngagementsChatPath(chatId);
            return logicController.getModelParam(myEngagementsChatPath);
        };

        logicController.getMyEngagementsChatPath = function (chatId, chatsRootModelPath) {
            chatsRootModelPath = getChatsRoomModelPath(chatsRootModelPath);
            var visitorId = logicController.getModelParam(chatsRootModelPath + '.' + chatId + '.visitorInfo.visitorId');
            var participantPath = logicController.getParticipantPath(visitorId);
            return participantPath + '.chats.' + chatId;
        };

        logicController.isMyChat = function (chatId) {
            // TODO: In Refactor!! Check if we still need the Agent Id and not the messagingUserId;
            var isMessaging = logicController.isEngagementAsyncMessaging(chatId);
            var agentIdPath = 'chats.' + chatId + '.agentInfo.' + (isMessaging ? 'messagingUserId' : 'agentId');

            var assignedAgent = logicController.getModelParam(agentIdPath);
            var currentAgent = logicController.getModelParam('agent');

            return isMessaging ? assignedAgent == currentAgent.messagingUserId : assignedAgent == currentAgent.id;
        };

        logicController.isActiveEngagement = function (visitorId, chatId) {
            var participantPath = logicController.getParticipantPath(visitorId);
            return logicController.getModelParam(participantPath + '.participantInfo.activeChat') === chatId;
        };
        logicController.isActiveChat = function (chatId, chatsRootModelPath) {
            chatsRootModelPath = getChatsRoomModelPath(chatsRootModelPath);

            return logicController.getModelParam(chatsRootModelPath + '.' + chatId + ".chatInfo.state") === logicController.chatStates.chatting;
        };
        logicController.setAgentSurveyLoadState = function (object) {
            logger.info({chatId: object.chatId}, "setAgentSurveyLoadState");
            model.modify("chats." + object.chatId + ".agentSurvey.active", object.state);
        };

        logicController.isSpectatedEngagement = function (visitorId) {
            var participantPath = logicController.getParticipantPath(visitorId);
            return logicController.getModelParam(participantPath + '.participantInfo.spectatedEngagement');
        };

        logicController.isAcceptedEngagement = function (visitorId) {
            var participantPath = logicController.getParticipantPath(visitorId);
            return logicController.getModelParam(participantPath + '.participantInfo.acceptedEngagement');
        };

        logicController.isAcceptedEngagementOrInMyEngagement = function (chatId, chatsRootModelPath) {
            chatsRootModelPath = getChatsRoomModelPath(chatsRootModelPath);
            return logicController.isAcceptedEngagementByChatId(chatId, chatsRootModelPath) || logicController.isInMyEngagements(chatId, chatsRootModelPath);
        };

        logicController.isSpectatedEngagementByChatId = function (chatId, chatsRootModelPath) {
            chatsRootModelPath = getChatsRoomModelPath(chatsRootModelPath);
            return logicController.getModelParam(chatsRootModelPath + '.' + chatId + '.visitorInfo.spectatedEngagement');
        };

        logicController.isAcceptedEngagementByChatId = function (chatId, chatsRootModelPath) {
            chatsRootModelPath = getChatsRoomModelPath(chatsRootModelPath);
            return logicController.getModelParam(chatsRootModelPath + '.' + chatId + '.visitorInfo.acceptedEngagement');
        };

        logicController.visitorHasChat = function (data) {
            /*|| data.state === 'WAITING_FOR_CHAT'*/
            return data.state ? data.state === 'IN_CHAT' || data.state === 'AFTER_CHAT' || data.state === 'LEFT_SITE' : false;
        };

        logicController.getAgentSkills = function (skill) {
            return logicController.getModelParam('agent.skillsInfo.skillInfo');
        };

        logicController.getSkillId = function (skill) {
            var skills = logicController.getModelParam('agent.skillsInfo.skillInfo') || [],
                resultId = 0;

            if (!_.isArray(skills)) {
                skills = [skills];
            }

            for (var i = 0; i < skills.length; i++) {
                if (skills[i].name === skill) {
                    resultId = skills[i].id;
                    break;
                }
            }

            return resultId;
        };

        logicController.agentHasSkill = function (skill) {
            var agentSkills = logicController.getAgentSkills();
            if (agentSkills) {
                for (var index = 0; index < agentSkills.length; index++) {
                    var skillInfo = agentSkills[index];
                    if (skillInfo &&
                        ((typeof skill === 'string' && skillInfo.name === skill) ||
                        (typeof skill === 'number' && skillInfo.id === skill))) {
                        return true;
                    }
                }
            }
            return false;
        };

        logicController.getAllDialogsOfConversation = function (convId, chatsRootModelPath) {
            chatsRootModelPath = getChatsRoomModelPath(chatsRootModelPath);
            return logicController.getModelParam(chatsRootModelPath + '.' + convId + '.chatInfo.dialogs');
        };

        logicController.getDialogOfConversation = function (convId, dialogId, chatsRootModelPath) {
            var dialogs = logicController.getAllDialogsOfConversation(convId, chatsRootModelPath);
            return dialogs && dialogs[dialogId];
        };

        logicController.getMainDialogOfConversation = function (convId, chatsRootModelPath) {
            var dialogs = logicController.getAllDialogsOfConversation(convId, chatsRootModelPath);
            return _.find(dialogs, function(dialog) { return dialog.dialogType === logicController.dialogTypes.MAIN; });
        };

        logicController.getActiveDialogIdOfConversation = function (convId, chatsRootModelPath) {
            var dialogs = logicController.getAllDialogsOfConversation(convId, chatsRootModelPath);
            var activeDialog = _.find(dialogs, function(dialog) { return dialog.state === logicController.conversationStates.OPEN; });
            return activeDialog && activeDialog.dialogId;
        };

        logicController.addIndicationToStartAndEndDialogLines = function (conversationLines, dialogs) {
            var LinesGroupedByDialogId = _.groupBy(conversationLines, function (line) { return line.dialogId; });

            _.each(LinesGroupedByDialogId, function (dialogLines, dialogId) {
                var firstLine = _.head(dialogLines);
                if (firstLine) {
                    firstLine.firstLineOfDialog = true;
                }

                if (dialogs[dialogId] && dialogs[dialogId].state === logicController.conversationStates.CLOSE) {
                    var lastLine = _.last(dialogLines);
                    if (lastLine) {
                        lastLine.lastLineOfDialog = true;
                    }
                }
            });
        };

        logicController.agentCanViewChat = function (engagementData) {
            var allChatsPrivilege = privilegesController.hasViewAllChatsPrivilege();
            return (allChatsPrivilege ? true : this.shouldSeeTableBySkill(engagementData));
        };

        logicController.shouldSeeTableBySkill = function (engagementData) {
            var skillChatPrivilege = privilegesController.hasViewSkillChatsPrivilege();
            var skillName = engagementData && (engagementData.skill || engagementData.skillName);
            return (!!skillName && !!skillChatPrivilege && this.agentHasSkill(skillName));
        };

        logicController.hasCKEditorPTagFeature = function () {
            return !!agentLEManager.getFeatureProperty("Common.LE_CKEditor_P_Tag");
        };

        logicController.getAgentGroup = function (agentGroupId) {
            if ('undefined' === typeof agentGroupId || null === agentGroupId) {
                return agentLEManager.translateLE('LEWebAgent.notAvailable');
            }

            var groupList = logicController.getAgentGroupsById();
            if (groupList.hasOwnProperty(agentGroupId.toString())) {
                return groupList[agentGroupId];
            }

            return agentLEManager.translateLE('LEWebAgent.notAvailable');
        };

        logicController.getSkillName = function (skillId) {
            if ('undefined' === typeof skillId || null === skillId || skillId + '' === '-1') {
                return agentLEManager.translateLE('LEWebAgent.unassigned');
            }
            return model.get('skills.data.' + skillId + '.name') || agentLEManager.translateLE('LEWebAgent.noSkillFound');
        };

        logicController.isLE2 = function () {
            return !!agentLEManager && !!agentLEManager.hasLiveEngage2Feature && agentLEManager.hasLiveEngage2Feature();
        };

        logicController.isRichContentEnabled = function () {
            return !!agentLEManager.getFeatureProperty("Common.RichContent");
        };

        logicController.isAcCoBrowseIntegrationEnabled = function () {
            return !!agentLEManager.getFeatureProperty("Cobrowse.Cobrowse_Integration");
        };

        logicController.isAcLiveVoiceIntegrationEnabled = function () {
            return !!agentLEManager.getFeatureProperty("LiveVoice.LiveVoice_Integration");
        };

        logicController.isAcLiveVideoIntegrationEnabled = function () {
            return !!agentLEManager.getFeatureProperty("LiveVideo.LiveVideo_Integration");
        };

        logicController.hasSecureFormsFeature = function () {
            return !!agentLEManager.getFeatureProperty("Common.SecureForms_LE2");
        };
        logicController.hasSecureFormsHistoryViewFeature = function () {
            return !!agentLEManager.getFeatureProperty('Reports.EngagementHistory_PCI_Data_Display');
        };

        logicController.hasIdnvFeature = function () {
            return !!agentLEManager.getFeatureProperty("Common.Identification_Verification");
        };

        logicController.hasAccountToAccountFeature = function () {
            return !agentLEManager.hasLiveEngage2Feature() && agentLEManager.getFeatureProperty("legacy.220");
        };


        logicController.hasSecureFormsViewPermission = function () {
            // * Secure Forms permissions granted to admins and privileged users.
            // The privilege for an agent manager (ID_LE_VIEW_AGENT_MANAGER_MODULE)is 1558.
            return !!agentLEManager.hasLEPrivilege(lpTag.WebAgent.privileges.privilegeIDs.VIEW_AC_SECURE_FORMS);
        };
        logicController.hasSecureFormsViewPermissionForHistory = function () {
            // * Secure Forms permissions granted to admins and privileged users.
            // The privilege for an agent manager in history (ID_LE_VIEW_AGENT_MANAGER_MODULE)is 1571.
            var privilege = !!agentLEManager.hasLEPrivilege(lpTag.WebAgent.privileges.privilegeIDs.VIEW_HISTORY_SECURE_FORMS);
            var ACFeature = !!agentLEManager.getFeatureProperty('Reports.EngagementHistory_PCI_Data_Display');

            return (privilege && ACFeature);
        };

        logicController.hasPermissionToSetConsumerProfile = function (chatId) {
            // * Set consumer profile permissions are granted to managers and assigned agents
            // AC feature "Messaging.AgentSetConsumerProfile" needs to be turned on.

            var ACFeature = !!agentLEManager.getFeatureProperty('Messaging.AgentSetConsumerProfile');
            var activeDialogId = logicController.getActiveDialogIdOfConversation(chatId);

            return ACFeature && privilegesController.hasUpdateConsumerProfileViaAPIPrivilege() &&
                (this.isLoggedInAgentManagerParticipant(chatId, activeDialogId) || this.isMyChat(chatId));
        };

        logicController.hasPCIDataWidgetSupport = function () {
            return lpTag.WebAgent.logicController.hasAuthenticatedChatFeature() && lpTag.WebAgent.logicController.hasSecureFormsFeature() && lpTag.WebAgent.logicController.hasSecureFormsViewPermission();
        };

        logicController.hasAgentViewPrivilege = function () {
            return !!agentLEManager.hasLEPrivilege(lpTag.WebAgent.privileges.privilegeIDs.LE_VIEW_AGENT_MODULE);
        };

        logicController.hasActiveConnectonsPrivilege = function () {
            //has 1734 privilege
            return !!agentLEManager.hasLEPrivilege(lpTag.WebAgent.privileges.privilegeIDs.VIEW_ACTIVE_CONNECTIONS);
        };

        logicController.isNonResponsiveDisabled = function () {
            return 'true' === LE.sessionManager.getAccountSettingValueByID(LE.sessionManager.ACCOUNT_SETTINGS_ID.DISABLED_NON_RESPONSE_STATE);
        };

        logicController.isFileSharingEnabled = function () {
            return 'true' === LE.sessionManager.getAccountSettingValueByID(LE.sessionManager.ACCOUNT_SETTINGS_ID.FILE_SHARING);
        };

        logicController.isAudioSharingEnabled = function () {
            return 'true' === LE.sessionManager.getAccountSettingValueByID(LE.sessionManager.ACCOUNT_SETTINGS_ID.AUDIO_MESSAGING);
        };

        logicController.isIconsForRealTimeDisabled = function(){
            return 'true' === LE.sessionManager.getAccountSettingValueByID(LE.sessionManager.ACCOUNT_SETTINGS_ID.WEBAGENT_DISABLE_ICONS_FOR_REALTIME);
        };
        logicController.isIconsForMessagingisabled = function(){
            return 'true' === LE.sessionManager.getAccountSettingValueByID(LE.sessionManager.ACCOUNT_SETTINGS_ID.WEBAGENT_DISABLE_ICONS_FOR_MESSAGING);
        };
        logicController.isAgentAlertOnPasteEnabled = function(){
            return 'true' === LE.sessionManager.getAccountSettingValueByID(LE.sessionManager.ACCOUNT_SETTINGS_ID.AGENT_ALERT_ON_PASTE);
        };

        logicController.isNonResponsivenNotifyTime = function () {
            var miliSec = LE.sessionManager.getAccountSettingValueByID(LE.sessionManager.ACCOUNT_SETTINGS_ID.NON_RESPONSE_NOTIFY_TIME);
            if(typeof miliSec === "number"){
                if(miliSec < 10000){
                    return 10000;
                }
                return miliSec;
            }
            return 10000;

        };

        logicController.isLPA = function () {
            var config = agentLEManager.getSessionConfig();
            return !!config && !!config.isLPA;
        };

        logicController.needAllOperatorsDataList = function() {
            // This is a temp. this value indicate accounts on CQM Servers.
            return agentLEManager.getAccountSettingValueByIdLE('le.agent.messaging.showAgentGroupFilter') === 'false';
        };

        logicController.hasEngagementHistoryFeature = function () {
            return !!agentLEManager.getFeatureProperty("Reports.LiveEngage_2_EngagementHistory");
        };

        logicController.hasMessagingAgentListEnabled = function () {
            return !!privilegesController.hasViewAgentListPrivilege();
        };

        logicController.hasMessagingSecureFormFeature = function () {
            return !!agentLEManager.getFeatureProperty("LEUI.Messaging_Secure_Form");
        };

        logicController.hasMessagingSurvey = function () {
            return !!agentLEManager.getFeatureProperty("Common.Messaging_Survey");
        };

        logicController.canTakeoverConversation = function () {
            return !!agentLEManager.getFeatureProperty("Common.Takeover_Conversation") && privilegesController.hasTakeoverPrivilege();
        };

        logicController.canGenerateSecureFormToken = function () {
            return !!agentLEManager.getFeatureProperty("Reports.GenerateSecureFormToken") && privilegesController.hasGenerateSecureFormTokenPrivilege() && this.hasMessagingSecureFormFeature();
        };

        logicController.hasVisitorFeedQueryFeature = function () {
            return !!agentLEManager.getFeatureProperty("VisitorFeed.Query");
        };

        logicController.hasSentimentAnalysisFeature = function () {
            // Although there is an AC feature for this, product decision was to roll it out for all clients. So there is no AC feature question here anymore.
            return privilegesController.hasAgentManagerModulePrivilege() || privilegesController.hasCampaignManagerModulePrivilege() || this.isSentimentAvailableForAll();
        };

        logicController.isSentimentAvailableForAll = function () {
            return agentLEManager.getMcsAgentViewIndication();
        };

        logicController.isCampaignManager = function () {
            privilegesController.hasCampaignManagerModulePrivilege();
        };

        logicController.hasUnifiedWindowFeature = function () {
            return !!agentLEManager.getFeatureProperty("Common.LiveEngage_2_Unified_window");
        };

        logicController.hasFeatureWhichBlocksHtmlSpaces = function () {
            return !!agentLEManager.getFeatureProperty('legacy.210') && !!agentLEManager.getFeatureProperty('legacy.425');
        };

        logicController.isAccountConfigUsersEnabled = function () {
            var usersSource = agentLEManager.getAccountSettingByIdLE('le.site.users.source');
            return !!usersSource && !usersSource.deleted && !!usersSource.propertyValue && !!usersSource.propertyValue.value && usersSource.propertyValue.value === 'LE';
        };

        logicController.hasProfileFeature = function () {
            return LE.sessionManager.hasProfilesFeature();
        };

        logicController.hasMultipleAgentSurvey = function () {
            var surveyType = agentLEManager.getAccountSettingByIdLE('le.agent.survey.support');
            return !!surveyType && !surveyType.deleted && !!surveyType.propertyValue && !!surveyType.propertyValue.value && surveyType.propertyValue.value === 'MULTIPLE';
        };

        logicController.hasMessagingFeature = function() {
            var isMessagingEnabled = !!agentLEManager.getFeatureProperty('Common.Async_Messaging') && !!logicController.isAccountConfigUsersEnabled();
            if(logicController.isAgentOnly()) {
                isMessagingEnabled = isMessagingEnabled && logicController.hasActiveConnectonsPrivilege();
            }
            return isMessagingEnabled;
        };

        logicController.isAgentOnly = function () {
            return (privilegesController.hasAgentViewPrivilege() &&
                 !privilegesController.hasCampaignManagerModulePrivilege() &&
                 !privilegesController.hasUsersViewPrivilege() &&
                 !privilegesController.hasAgentManagerModulePrivilege());
        };

        logicController.hasCoBrowseFeature = function (type) {
            var cobrowseSupported = logicController.isLE2() && logicController.isAcCoBrowseIntegrationEnabled();
            if ('app' === type) {
                return cobrowseSupported && LE.siteSettings.cobrowseSettings.appEngagement.isEnabled();
            } else {
                return cobrowseSupported && !LE.siteSettings.cobrowseSettings.isCoBrowseDisabled();
            }
        };

        logicController.hasLiveVoiceFeature = function () {
            var liveVoiceSupported = logicController.isLE2() && logicController.hasMessagingFeature() && logicController.isAcLiveVoiceIntegrationEnabled();
            return liveVoiceSupported && LE.siteSettings.cobrowseSettings.appEngagement.isEnabled();
        };

        logicController.hasLiveVideoFeature = function () {
            var liveVideoSupported = logicController.isLE2() && logicController.hasMessagingFeature() && logicController.isAcLiveVideoIntegrationEnabled();
            return liveVideoSupported && LE.siteSettings.cobrowseSettings.appEngagement.isEnabled();
        };

        logicController.hasAuthenticatedChatFeature = function () {
            return !!agentLEManager.getFeatureProperty('Common.Authenticated_Chat');
        };

        logicController.hasIdnv = function () {
            return (logicController.isLE2() && logicController.hasIdnvFeature());
        };

        logicController.useCannedResponsesACService = function () {
            var cannedResponsesSource = agentLEManager.getAccountSettingByIdLE("le.site.cannedResponses.source");
            return cannedResponsesSource && cannedResponsesSource.propertyValue && cannedResponsesSource.propertyValue.value && cannedResponsesSource.propertyValue.value === "LE";
        };

        logicController.useAutoAcceptForMessaging = function () {
            var isAutoAccept = agentLEManager.getAccountSettingValueByIdLE('messaging.routing.autoaccept');
            return isAutoAccept === "true";
        };

        logicController.enableEncryptedSearch = function () {
            var isEncryptedSearchEnabled = agentLEManager.getAccountSettingValueByIdLE('le.encryption.search');
            return isEncryptedSearchEnabled === "true";
        };

        logicController.enableBlockVisitorName = function() {
            var isBlockVisitorNameEnabled = agentLEManager.getAccountSettingValueByIdLE('le.agent.block.visitor.name');
            return isBlockVisitorNameEnabled === "true" && logicController.isAgentOnly();
        };

        logicController.isSearchOnTranscriptEnabled = function() {
            return !agentLEManager.hasDataEncryptionFeature() || logicController.enableEncryptedSearch();
        };

        logicController.getConnectionStatus = function () {
            return this.getModelParam("agent.connectionState");
        };

        logicController.getChatAvailability = function () {
            return this.getModelParam("agent.chatAvailability");
        };

        logicController.isConnectionStatusActive = function () {
            return (_.isEqual(this.getConnectionStatus(), this.connectionStates.ACTIVE));
        };

        logicController.getAmsConnectionStatus = function () {
            return this.getModelParam("amsService.socketState");
        };

        logicController.isAmsConnectionStatusActive = function () {
            return (_.isEqual(this.getAmsConnectionStatus(), 'connected') || _.isEqual(this.getAmsConnectionStatus(), 'recovered'));
        };

        logicController.isAppServerOrAmsConnectionStatusActive = function () {
            return logicController.isConnectionStatusActive() || logicController.isAmsConnectionStatusActive();
        };

        logicController.isCsatViewEnabled = function () {
            //This is configurable in nightvision (with account setting). When product decides to move this to the profiles configuration,
            //the return statement will just be a question to the privilege and not the 3 it is at the moment.
            return privilegesController.hasAgentManagerModulePrivilege() || privilegesController.hasCampaignManagerModulePrivilege() || this.isCSATAvailableForAll();
        };

        logicController.isCSATAvailableForAll = function () {
            return this.parseTrueOrFalseStringToBool(LE.sessionManager.getAccountSettingValueByID(LE.sessionManager.ACCOUNT_SETTINGS_ID.CSAT_AGENT_VIEW));
        };

        logicController.getVisitorPredefinedContentLang = function (visitorId, chatId) {
            var predefinedContent = this.getModelParam("preDefinedContent");
            if (predefinedContent) {

            if (logicController.useCannedResponsesACService() && chatId) {
                var skillsSet = _getSkillIdTextFromList(logicController.getChatSkillIds(chatId));
                var participantPath = logicController.getParticipantPath(visitorId);
                var participantDataPath = logicController.getParticipantDataPath(visitorId);
                var visitorLang = this.getModelParam(participantPath + '.participantInfo.lang') || this.getModelParam(participantDataPath + '.data.engagement.language');
                if (visitorLang && predefinedContent[skillsSet] && predefinedContent[skillsSet][visitorLang]) {
                    return visitorLang;
                }
            }

                return agentLEManager.getDefaultLanguage();
            }

            function _getSkillIdTextFromList(skillIds) {
                return (skillIds && skillIds.length) ? skillIds.join('_') : 'unSkillChat';
            }
        };

        logicController.getSentimentTag = function (sentimentScore) {
            switch (sentimentScore) {
                case -1:
                    return logicController.sentimentMap.negative;
                case 1:
                    return logicController.sentimentMap.positive;
                default:
                    return logicController.sentimentMap.neutral;
            }
        };

        logicController.hideEngagement = function (chatId, visitorId, chatsObj, myEngagementsChatObj) {
            var newObject = jQuery.extend(true, {}, myEngagementsChatObj); //todo use underscore maybe
            var chatsObjCopy = lpUtils.cloneObject(chatsObj);

            //dispose
            lpTag.WebAgent.AppMediator.setAgentTyping({
                chatId: chatId,
                typing: false
            });
            logicController.disposeParticipant(visitorId, true);
            window.App.viewEventsHandler.fireEvent({
                appName: visitorId,
                UIEvent: window.App.viewEventsHandler.eventType.VISITOR_DISPOSED,
                eventData: {visitorId: visitorId},
                deleteOnFire: true
            });


            //if we need to restart - do it
            if (chatsObjCopy && !_.isEmpty(chatsObjCopy)) {

                //add the split session texts
                for (var chat in chatsObjCopy) {
                    model.set("chats." + chat, chatsObjCopy[chat]);
                }

                //add the obj to myEngagements. This will re-render the engagement
                model.set("participants.myEngagements." + visitorId, newObject);
            }
        };

        logicController.disposeParticipant = function (visitorId, isRestart) {
            logger.info({visitorId: visitorId}, "disposeParticipant");

            lpTag.WebAgent.channel.publish(
                webAgentStatics.COMMUNICATION_CHANNELS.AppEvents.name,
                webAgentStatics.COMMUNICATION_CHANNELS.AppEvents.events.beforeVisitorDisposed,
                {
                    visitorId: visitorId
                }
            );

            var participantPath = logicController.getParticipantPath(visitorId);
            var chats = model.get(participantPath + '.chats');

            disposeOpenEngagementChannels(visitorId);

            model.unbind(participantPath + '.chats', handleNewChat, logicController);
            model.unbind(participantPath + '.participantInfo.acceptedEngagement', handleEngagementAccepted, logicController);

            for (var prop in chats) {
                if (chats.hasOwnProperty(prop)) {
                    var chatId = chats[prop];

                    model.unbind('chats.' + chatId + '.agentSurvey.survey', chatHasSurvey, logicController);
                    model.unbind('chats.' + chatId + '.agentSurvey.survey.surveyState', surveyStateChanged, logicController);
                    model.unbind('chats.' + chatId + '.chatInfo.state', chatStateChanged, logicController);
                    switch (logicController.getEngagementTypeByChatId(chatId)) {
                        case logicController.engagementTypes.realTimeChat :
                            model.removeKey('chats.' + chatId);
                            break;
                        case logicController.engagementTypes.asyncMessaging :
                            // explicitly trigger remove for any chat associated with this engagement
                            model.removeKey(participantPath + '.chats.' + prop);
                            model.removeKey('chats.' + chatId + '.newChatLine');
                            model.removeKey('chats.' + chatId + '.oldChatLine');
                            break;
                        case logicController.engagementTypes.unknown:
                            logger.warn(visitorId + " has unknown engagement type", "disposeParticipant");
                            model.removeKey("chats." + chatId);
                            break;
                    }

                    if (lpAgent.chat && !isRestart) {
                        lpAgent.chat.chatCompleted(chatId);
                    }
                }
            }
            logicController.participants[visitorId] = null;
            delete logicController.participants[visitorId];

            updateNumberOfActiveEngagements();

            model.removeKey(participantPath);
            if (lpTag && lpTag.participant && !isRestart) {
                lpTag.participant.disposeParticipant(visitorId);
            }
            var participantsCount = model.get("agent.numOfParticipants");
            model.modify("agent.numOfParticipants", participantsCount - 1);

            lpTag.WebAgent.channel.publish(
                webAgentStatics.COMMUNICATION_CHANNELS.AppEvents.name,
                webAgentStatics.COMMUNICATION_CHANNELS.AppEvents.events.visitorDisposed,
                {
                    visitorId: visitorId
                }
            );
        };

        logicController.getParticipantPath = function (visitorId) {
            if (!visitorId) {
                return null;
            }
            var engagementPath = lpTag.WebAgent.engagementSimulator && visitorId === lpTag.WebAgent.engagementSimulator.SIMULATED_PARTICIPANT_ID ? "simulatedEngagements" : "myEngagements";
            return "participants." + engagementPath + "." + visitorId;
        };

        logicController.getParticipantDataPath = function (visitorId) {
            return 'participants.info.' + visitorId;
        };

        logicController.getConversationDetailsPath = function (chatId) {
            var pathSuffix;
            if (logicController.hasMessagingFeature()) {
                pathSuffix = '.conversationDetails';
            } else {
                pathSuffix = '';
            }
            return lpAMSController.MODEL_PATHS.connectionsListModelLocations.data + '.' + chatId + pathSuffix;
        };

        logicController.isVisitorMonitored = function (visitorId) {
            return !!model.get(logicController.getParticipantPath(visitorId) + '.participantInfo.shark');
        };

        /* TODO: Remove */
        logicController.getConversationNotePath = function (chatId) {
            return logicController.getConversationDetailsPath(chatId) + '.note';
        };

        /* TODO: Remove */
        logicController.getConversationStatePath = function (chatId) {
            return logicController.getConversationDetailsPath(chatId) + '.state';
        };

        logicController.getEngagementTypeByChatId = function (chatId, chatsRootModelPath) {
            chatsRootModelPath = getChatsRoomModelPath(chatsRootModelPath);
            var chat = model.get(chatsRootModelPath + '.' + chatId + '.chatInfo');
            if (chat) {
                if (chat.hasOwnProperty('engagementType') && logicController.engagementTypes.hasOwnProperty(chat.engagementType)) {
                    return logicController.engagementTypes[chat.engagementType];
                }
            } else {
                return logicController.engagementTypes.unknown;
            }

            return logicController.engagementTypes.realTimeChat;
        };

        logicController.isEngagementAsyncMessaging = function (chatId, chatsRootModelPath) {
            chatsRootModelPath = getChatsRoomModelPath(chatsRootModelPath);
            return logicController.getEngagementTypeByChatId(chatId, chatsRootModelPath) === logicController.engagementTypes.asyncMessaging;
        };

        logicController.isEngagementRealTimeChat = function (chatId, chatsRootModelPath) {
            chatsRootModelPath = getChatsRoomModelPath(chatsRootModelPath);
            return logicController.getEngagementTypeByChatId(chatId, chatsRootModelPath) === logicController.engagementTypes.realTimeChat;
        };

        logicController.isSimulatedVisitor = function (visitorId) {
            var isSimulated = false;
            if (visitorId) {
                isSimulated = !!model.get("participants.simulatedEngagements." + visitorId);
            }
            return isSimulated;
        };

        logicController.isSimulatedEngagement = function (chatId) {
            var visitorId = logicController.getModelParam('chats.' + chatId + '.visitorInfo.visitorId');
            return logicController.isSimulatedVisitor(visitorId);
        };

        logicController.getEngagementTypeByVisitorId = function (visitorId) {
            var isVisitorInModel = model.get("participants.myEngagements." + visitorId);
            if (isVisitorInModel) {
                var engagementType = model.get("participants.myEngagements." + visitorId + ".participantInfo.engagementType");
                if (engagementType) {
                    return engagementType;
                } else {
                    return logicController.engagementTypes.realTimeChat;
                }
            } else {
                return logicController.engagementTypes.unknown;
            }
        };

        logicController.isLineNeedToBeNotified = function (chatLine, chatId) {
            var isAsyncMessaging = logicController.isEngagementAsyncMessaging(chatId);
            if (!isAsyncMessaging) {
                return chatLine && (chatLine.source === 'visitor' || (chatLine.by && chatLine.by !== model.get('agent.agentName')));
            } else {
                var mainDialogId = logicController.getMainDialogOfConversation(chatId).dialogId;
                return chatLine && (mainDialogId === chatLine.dialogId) && ((chatLine.source === 'visitor') || (chatLine.originatorId !== model.get('agent.messagingUserId')));
            }
        };

        logicController.hasUnreadMessagesCounter = function (chatId) {
            var activeDialogId = logicController.getActiveDialogIdOfConversation(chatId);
            // messaging && (Owner of the conversation  || Manager in the conversation).
            return logicController.isEngagementAsyncMessaging(chatId) && (logicController.isAcceptedEngagementByChatId(chatId) || logicController.isLoggedInAgentManagerParticipant(chatId, activeDialogId));
        };

        logicController.isVisitorAsyncMessaging = function (visitorId) {
            return logicController.getEngagementTypeByVisitorId(visitorId) === logicController.engagementTypes.asyncMessaging;
        };

        logicController.isVisitorRealTimeChat = function (visitorId) {
            return logicController.getEngagementTypeByVisitorId(visitorId) === logicController.engagementTypes.realTimeChat;
        };

        logicController.chatStateToEngagementState = function (chatId, chatState) {
            switch (chatState) {
                case logicController.chatStates.ended:
                    if (hasPendingSurvey(chatId)) {
                        return logicController.engagementStates.inactive;
                    } else {
                        return logicController.engagementStates.completed;
                    }
                    break;
                case logicController.chatStates.chatting:
                    return logicController.engagementStates.active;
                default:
                    break;
            }
        };

        logicController.conversationStateToEngagementState = function (conversationState) {
            switch (conversationState) {
                case logicController.conversationStates.OPEN:
                    return logicController.engagementStates.active;
                case logicController.conversationStates.CLOSE:
                    return logicController.engagementStates.inactive;
                case logicController.conversationStates.LOCKED:
                    return logicController.engagementStates.completed;
                default:
                    return logicController.engagementStates.active;
            }
        };

        logicController.conversationStateToChatState = function (conversationState) {
            switch (conversationState) {
                case logicController.conversationStates.OPEN:
                    return logicController.chatStates.chatting;
                case logicController.conversationStates.CLOSE:
                    return logicController.chatStates.ended;
                case logicController.conversationStates.LOCKED:
                    return logicController.chatStates.ended;
                default:
                    return logicController.chatStates.chatting;
            }
        };

        logicController.setLoggedInAgentPeekerParticipant = function (conversationId, dialogId, isPeeker) {
            logger.debug('setting logged in agent peeker participation value to [' + isPeeker + '] for conversation [' + conversationId + '] on dialog [' + dialogId + ']', 'setLoggedInAgentPeekerParticipant');
            var modelPath = logicController.getPeekerParticipantPath(conversationId, dialogId);
            if (isPeeker) {
                model.set(modelPath, isPeeker);
            } else {
                model.removeKey(modelPath);
            }
        };

        /**
         * a peeker participant is set when an agent is participating a conversation as a reader via opening the
         * table widget (as opposed to via opening the engagement area).
         *
         * @param conversationId
         * @returns {*}
         */
        logicController.isLoggedInAgentPeekerParticipant = function (conversationId, dialogId) {
            var modelPath = logicController.getPeekerParticipantPath(conversationId, dialogId);
            return model.get(modelPath);
        };

        logicController.getPeekerParticipantPath = function (conversationId, dialogId, chatsRootModelPath) {
            chatsRootModelPath = getChatsRoomModelPath(chatsRootModelPath);
            var loggedInAgentIdModelKey = logicController.modelPatcher.toSafeKeySegment(model.get('agent.messagingUserId'));
            return chatsRootModelPath + '.' + conversationId + '.peekersInfo.' + dialogId + '.' + loggedInAgentIdModelKey;
        };

        /**
         * Gets the current time in milliseconds, taking into account a server timeDiff
         * @param timeDiff The server timeDiff
         */
        logicController.getCurrentTimeWithDiff = function (timeDiff) {
            var time = logicController.getCurrentTime();
            if (typeof timeDiff === 'number') {
                time -= timeDiff;
            }
            return time;
        };

        /**
         * Gets the current time in milliseconds
         * @returns {number}
         */
        logicController.getCurrentTime = function () {
            return new Date().getTime();
        };

        logicController.getOnlinePresenceSiteSetting = function () {
            var onlinePresenceObj = agentLEManager.getAccountSettingValueByIdLE('le.agent.messaging.OnlinePresence');
            return {
                enabled: onlinePresenceObj.enabled === 'true',
                updateInterval: onlinePresenceObj.updateInterval
            };
        };


        logicController.getMessagingSdesSiteSetting = function () {
            var messagingSdesObj = agentLEManager.getAccountSettingValueByIdLE('le.agent.messaging.sdes');
            return messagingSdesObj !== "false";
        };

        logicController.getGenerateTokenTimeoutSiteSettings = function() {
            var settings = agentLEManager.getAccountSettingValueByIdLE('le.agent.generate.token.timeout.sec');
            if(_.isNumber(settings)) {
                return settings * 1000;
            }
            return null;
        };

        logicController.getOpenConnectionsFilterDeletedAgentsSiteSetting = function () {
            var showFilterDeletedAgents = agentLEManager.getAccountSettingValueByIdLE('le.agents.open.connections.agent.name.new.filter');
            return showFilterDeletedAgents !== 'false';
        };

        logicController.isAutoOpenConversation = function (visitorId) {
            return !!logicController.getModelParam(logicController.getParticipantPath(visitorId) + '.participantInfo.autoOpen');
        };

        logicController.getChatStateByChatId = function (chatId, chatsRootModelPath) {
            chatsRootModelPath = getChatsRoomModelPath(chatsRootModelPath);
            return model.get(chatsRootModelPath + '.' + chatId + ".chatInfo.state");
        };
        logicController.getConversationStateByChatId = function (chatId, chatsRootModelPath) {
            chatsRootModelPath = getChatsRoomModelPath(chatsRootModelPath);
            return model.get(chatsRootModelPath + '.' + chatId + ".chatInfo.messagingState");
        };
        logicController.getEngagementStateByChatId = function (chatId, chatsRootModelPath) {
            chatsRootModelPath = getChatsRoomModelPath(chatsRootModelPath);
            if (logicController.isEngagementAsyncMessaging(chatId, chatsRootModelPath)) {
                return logicController.conversationStateToEngagementState(logicController.getConversationStateByChatId(chatId, chatsRootModelPath));
            } else {
                return logicController.chatStateToEngagementState(chatId, logicController.getChatStateByChatId(chatId, chatsRootModelPath));
            }
        };

        logicController.updateParticipantTag = function (visitorId, color) {
            if (logicController.participants[visitorId]) {
                logicController.participants[visitorId].colorScheme = color;
                var participantPath = logicController.getParticipantPath(visitorId);
                model.modify(participantPath + ".participantTag", color);
            }
        };

        function collectionHasValue(objectArray, propKey, matchValue) {
            var propValueArray = _.pluck(objectArray, propKey);
            return _.contains(propValueArray, matchValue);
        }

        function handleNewParticipant(data) {
            if (data && data.newValue) {
                var visitors = Object.keys(data.newValue);
                for (var visitor in visitors) {
                    var visitorId = visitors[visitor];
                    handleSingleNewParticipant(visitorId);
                }
            }
        }

        function handleSingleNewParticipant(visitorId) {
            if (!logicController.participants[visitorId]) {
                logicController.participants[visitorId] = {};
                var participantPath = logicController.getParticipantPath(visitorId);
                model.bind(participantPath + ".participantTag", handleTagChanged);
                model.bind(participantPath + ".chats", handleNewChat);
                var participantsCount = model.get("agent.numOfParticipants") || 0;//for first time only
                model.modify("agent.numOfParticipants", participantsCount + 1);
            }
        }

        function handleTagChanged(data) {
            if (typeof data.newValue === 'undefined') {
                return;
            }
            var visitorId = data.key.split(".")[2];
            var tag = data.newValue;
            if (logicController.isAcceptedEngagement(visitorId)) {
                if (!logicController.participants[visitorId].colorScheme) {
                    tag = getParticipantTag();
                    logicController.participants[visitorId].colorScheme = tag;
                } else {
                    tag = logicController.participants[visitorId].colorScheme;
                }
            } else if (logicController.isSpectatedEngagement(visitorId)) {
                tag = logicController.defaultColorScheme;
            }
            if (tag) {// 16/2/14 ElaA - protection from multi callbacks BUG (LPModel)
                var participantPath = logicController.getParticipantPath(visitorId);
                model.modify(participantPath + ".participantTag", tag);
            }
        }

        function getParticipantTag() {
            var tag = logicController.colorsScheme[logicController.colorIndex];
            logicController.colorIndex++;
            if (logicController.colorIndex >= logicController.colorsScheme.length) {
                logicController.colorIndex = 0;
            }
            return tag;
        }

        function handleNewChat(data) {
            if (data && data.newValue) {
                var chatIds = Object.keys(data.newValue);
                var chatId, visitorId, participantPath;
                for (var chat in chatIds) {
                    chatId = chatIds[chat];
                    visitorId = model.get("chats." + chatId + ".visitorInfo.visitorId");
                    participantPath = logicController.getParticipantPath(visitorId);
                    if (model.get(participantPath) == null) {
                        return;
                    }

                    if (!logicController.participants[visitorId].chat || logicController.participants[visitorId].chat.id !== chatId) {
                        var acceptedEngagement = false;
                        if (logicController.isAcceptedEngagement(visitorId)) {
                            acceptedEngagement = true;
                        } else {
                            model.bind(participantPath + '.participantInfo.acceptedEngagement', handleEngagementAccepted, logicController); // this is done for the case that it will become my chat due to transfer
                        }
                        getUpdatedCannedAnswers(chatId);
                        var chatState = model.get("chats." + chatId + ".chatInfo.state");
                        logicController.openEngagementChannel(visitorId, 'chat', {
                            id: chatId,
                            state: chatState,
                            acceptedEngagement: acceptedEngagement
                        }, []);
                        logicController.openEngagementChannel(visitorId, 'chat', {
                            id: chatId,
                            state: chatState,
                            acceptedEngagement: acceptedEngagement
                        }, []);
                        model.bind("chats." + chatId + ".agentSurvey.survey", chatHasSurvey, logicController);
                        model.bind("chats." + chatId + ".chatInfo.state", chatStateChanged, logicController);
                        chatStateChanged({newValue: chatState, chatId: chatId});
                        updateEngagementState(visitorId);
                    }
                }
            }

        }
        function getUpdatedCannedAnswers(chatId) {
            var nowTime = new Date().getTime();
            if (lpTag.WebAgent.cannedAnswersController && logicController.useCannedResponsesACService() &&
                ((nowTime - logicController.fetchRequestLatestTime) >= logicController.fetchRequestBufferTime || logicController.useCannedResponsesACService )) { //TODO add manifest condition before merge to master
                logicController.fetchRequestLatestTime = nowTime;
                lpTag.WebAgent.cannedAnswersController.fetchData(chatId);
            }
        }

        function handleEngagementAccepted(data) {
            if (!data.newValue) {
                return;
            }
            var visitorId = data.key.split(".")[2];
            if (logicController.participants[visitorId] && !logicController.participants[visitorId].chat.acceptedEngagement) {
                logicController.participants[visitorId].chat.acceptedEngagement = true;
                updateNumberOfActiveEngagements();
            }
        }

        function chatStateChanged(data) {
            if (!data.newValue) {
                return;
            }
            var chatId = data.chatId || data.key.split(".")[1];
            var visitorId = model.get("chats." + chatId + ".visitorInfo.visitorId");
            var chatObj = logicController.participants[visitorId] ? logicController.participants[visitorId].chat : null;
            if (chatObj && chatObj.id === chatId) {
                // TODO: why are we having here states that are not in the list of states?
                chatObj.state = logicController.chatStateToEngagementState(chatId, data.newValue) || chatObj.state;
            }
            updateEngagementState(visitorId);
            getUpdatedCannedAnswers(chatId);
        }

        function hasPendingSurvey(chatId, chatsRootModelPath) {
            chatsRootModelPath = getChatsRoomModelPath(chatsRootModelPath);

            var surveyObj = model.get(chatsRootModelPath + '.' + chatId + ".agentSurvey.survey");
            var surveyPending;
            if (surveyObj) {
                surveyPending = surveyObj.surveyState === "Wait";
            }
            return surveyObj && surveyPending;
        }

        function chatHasSurvey(data, chatsRootModelPath) {
            chatsRootModelPath = getChatsRoomModelPath(chatsRootModelPath);


            var chatId = data.key.split(".")[1];
            var visitorId = model.get(chatsRootModelPath + '.' + chatId + ".visitorInfo.visitorId");
            var surveyObj = model.get(chatsRootModelPath + '.' + chatId + ".agentSurvey");
            if (surveyObj) {
                model.bind(chatsRootModelPath + '.' + chatId + ".agentSurvey.survey.surveyState", surveyStateChanged, logicController);
                surveyObj = null;
            }
        }

        function surveyStateChanged(data, chatsRootModelPath) {
            chatsRootModelPath = getChatsRoomModelPath(chatsRootModelPath);


            var chatId = data.key.split(".")[1];
            var visitorId = model.get(chatsRootModelPath + '.' + chatId + ".visitorInfo.visitorId");
            if (this.participants[visitorId]) {
                if (data.newValue && (data.newValue === "Filled" || data.newValue === "Filled-and-Wait")) {
                    if (this.participants[visitorId].chat && this.participants[visitorId].chat.state === logicController.engagementStates.inactive) {
                        this.participants[visitorId].chat.state = logicController.engagementStates.completed;
                    }
                } else if (data.newValue && data.newValue === "Wait") {
                    if (this.participants[visitorId].chat && this.participants[visitorId].chat.state === logicController.engagementStates.completed) {
                        this.participants[visitorId].chat.state = logicController.engagementStates.inactive;
                    }
                }
            }
            updateEngagementState(visitorId);
        }

        function updateEngagementState(visitorId) {
            var participantPath = logicController.getParticipantPath(visitorId);
            if (model.get(participantPath) == null) {
                return;
            }

            var engagementState = logicController.engagementStates.completed;
            var currentState = model.get(participantPath + ".participantState.engagementState");
            var chatEngagementChannel = getEngagementChannel(visitorId, logicController.ENGAGEMENT_CHANNELS.CHAT);

            // sync the engagement state with the chat state.
            if (chatEngagementChannel.state === logicController.engagementStates.active) {
                engagementState = logicController.engagementStates.active;
            } else if (chatEngagementChannel.state === logicController.engagementStates.inactive) {
                engagementState = logicController.engagementStates.inactive;
            }

            if (engagementState !== logicController.engagementStates.active) {
                disposeOpenEngagementChannels(visitorId);
            }
            if (currentState !== engagementState) {//TODO check if protected
                model.modify(participantPath + ".participantState.engagementState", engagementState);
            }
            updateNumberOfActiveEngagements();
        }

        function disposeOpenEngagementChannels(visitorId) {
            var chatEngagementDependantChannels = getEngagementDependantChannels(visitorId, logicController.ENGAGEMENT_CHANNELS.CHAT, false);
            for (var i = 0; i < chatEngagementDependantChannels.length; i++) {
                logicController.closeEngagementChannel(visitorId, chatEngagementDependantChannels[i].channelName);
            }
        }

        function updateNumberOfActiveEngagements() {
            var numOfActiveChats = 0;
            var numOfActiveConversations = 0;
            for (var visitorId in logicController.participants) {
                if (logicController.participants.hasOwnProperty(visitorId)) {
                    if (logicController.participants[visitorId].chat &&
                        logicController.participants[visitorId].chat.acceptedEngagement &&
                        logicController.participants[visitorId].chat.state === logicController.engagementStates.active) {
                        if (logicController.isEngagementAsyncMessaging(logicController.participants[visitorId].chat.id)) {
                            numOfActiveConversations++;
                        } else {
                            numOfActiveChats++;
                        }
                    }
                }
            }
            logicController.numOfActiveChats = numOfActiveChats;
            logicController.numOfActiveConversations = numOfActiveConversations;
            model.modify("agent.numOfActiveRealTimeChats", numOfActiveChats);
            model.modify("agent.numOfActiveAsyncMessagingConversations", numOfActiveConversations);
            model.modify("agent.numOfActiveEngagements", numOfActiveChats + numOfActiveConversations);
            checkMaxChatsReached();
            logger.info("numOfActiveChats=" + numOfActiveChats, "updateNumberOfActiveEngagements");
            logger.info("numOfActiveConversations=" + numOfActiveConversations, "updateNumberOfActiveEngagements");
        }

        function handleMaxChatUpdated(data) {
            logicController.maxChatsAllowed = data.newValue ? parseInt(data.newValue, 10) : 0;
            checkMaxChatsReached();
        }

        function checkMaxChatsReached() {
            model.modify("agent", {isMaxChats: logicController.maxChatsAllowed === logicController.numOfActiveChats});
        }

        /**
         * Model clean ups after logged out
         *
         * @param data
         */
        function handleStatusChanged(data) {
            if (typeof data.newValue !== 'undefined') {
                if (data.newValue === 'loggedIn') {
                    // If this feature is enabled, we need to perform the request for widgets prior to the postInitialization method
                    lpTag.WebAgent.agentWidgetsController.getAgentWidgetsData({
                        success: lpTag.agent.postInitialization,
                        error: lpTag.agent.postInitialization
                    });
                } else {
                    var statusId = logicController.getModelParam("application.error.statusId") || logicController.getModelParam("application.error.internalCode");
                    var errorMessage = logicController.getModelParam("application.error.message");

                    if (model.get("participants")) {
                        model.removeKey("participants");
                    }
                    if (model.get("chats")) {
                        model.removeKey("chats");
                    }
                    if (model.get("agent")) {
                        model.removeKey("agent");
                    }
                    if (model.get("application")) {
                        model.removeKey("application");
                    }
                    if (model.get("username")) {
                        model.removeKey("username");
                    }
                    if (model.get("password")) {
                        model.removeKey("password");
                    }
                    lpTag.WebAgent.agentController.participantsCounter = 0;
                    logicController.numOfActiveChats = 0;
                    logicController.numOfActiveConversations = 0;
                    logicController.colorIndex = 0;

                    handleAgentLogout(statusId, errorMessage);
                }
            }
        }

        function handleAgentLogout(statusId, errorMessage) {
            if (logicController.authErrorMethod && logicController.authErrorTypes) { // check if we got thrown from the session with an error code.
                if (statusId === 11) { // currently we know this indicates an expired/disabled site
                    if (errorMessage) { // since no other way to indicate the root cause, we relay on the message string
                        if (errorMessage.indexOf("expired") !== -1) { // site expired
                            return logicController.authErrorMethod(logicController.authErrorTypes.SITE_EXPIRED);
                        } else if (errorMessage.indexOf("disabled") !== -1) { // site disabled
                            return logicController.authErrorMethod(logicController.authErrorTypes.SITE_DISABLED);
                        } else if (errorMessage.indexOf("concurrent") !== -1) { // agent max concurrency reached
                            if (LE && LE.siteSettings && LE.siteSettings.featureSettings && _.isFunction(LE.siteSettings.featureSettings.hasBlockAddingUsersFeature) && LE.siteSettings.featureSettings.hasBlockAddingUsersFeature()) {
                                return logicController.authErrorMethod(logicController.authErrorTypes.ONE_SEAT);
                            } else {
                                return reValidateSession();
                            }
                        }
                    }
                } else if (statusId === 12) { // operator disabled
                    if (errorMessage && errorMessage.indexOf("disabled") !== -1) {
                        return logicController.authErrorMethod(logicController.authErrorTypes.OPERATOR_DISABLED);
                    }
                } else if (statusId === 27) { // server unavailable (27)
                    return reValidateSession();
                }
                return logicController.authErrorMethod(logicController.authErrorTypes.GENERAL_ERROR); // if we reached here, throw the session on "general error"
            }
        }

        function reValidateSession() {
            if (logicController.revalidateSession) {
                logger.info("", "reValidateSession");
                logicController.revalidateSession();
            }
        }

        model.bind("application.status", handleStatusChanged, this);
        model.bind("agent.maxChats", handleMaxChatUpdated, this);
        model.bind("participants.myEngagements", handleNewParticipant, this);
        model.bind("participants.simulatedEngagements", handleNewParticipant, this);

        logicController.openEngagementChannel = function (visitorId, channelName, channelData, dependencies, closeHandler) {
            logicController.participants[visitorId][channelName] = channelData;
            // setting permanent meta-data attributes into the object.
            channelData.isEngagementChannel = true;
            channelData.dependencies = dependencies;
            channelData.isActive = true;
            channelData.channelName = channelName;
            channelData.closeHandler = closeHandler;
        };

        logicController.closeEngagementChannel = function (visitorId, channelName) {

            var channel = logicController.getEngagementChannel(visitorId, channelName);

            if (channel) {
                if (channel.closeHandler) {
                    channel.closeHandler(onCloseDone);
                }
                else {
                    onCloseDone();
                }
            }

            function onCloseDone() {
                delete logicController.participants[visitorId][channelName];
            }

        };

        logicController.getEngagementDependantActiveChannels = function (visitorId, channelName) {
            return getEngagementDependantChannels(visitorId, channelName, true);
        };

        logicController.getEngagementChannel = function (visitorId, channelName) {
            return getEngagementChannel(visitorId, channelName);
        };

        /**
         * Return a Calculated value of the Refresh rate if the settings is found.
         * if the setting is not found, use the fallback value (2nd argument) or the minimum Time.
         * @param siteSettingsKey - the key of the site settings.
         * @param fallbackValue - the value to return if no value can be extracted from the site settings
         * @returns {*} - returns the pooling time in milliseconds
         */
        logicController.getPollingRefreshRateFromSiteSettings = function (siteSettingsKey, fallbackValue) {
            var MINIMUM_REFRESH_RATE_IN_SEC = 10;
            var SECOND_UNIT = 1000;

            var siteSettingsRecord = agentLEManager.getAccountSettingByIdLE(siteSettingsKey);
            if (siteSettingsRecord && siteSettingsRecord.propertyValue && siteSettingsRecord.propertyValue.value && siteSettingsRecord.propertyValue.value >= MINIMUM_REFRESH_RATE_IN_SEC) {
                return siteSettingsRecord.propertyValue.value * SECOND_UNIT;
            }

            return fallbackValue || (MINIMUM_REFRESH_RATE_IN_SEC * SECOND_UNIT);
        };

        function getEngagementChannel(visitorId, channelName) {
            if (logicController.participants[visitorId] && logicController.participants[visitorId].hasOwnProperty(channelName) &&
                logicController.participants[visitorId][channelName].isEngagementChannel) {
                return logicController.participants[visitorId][channelName];
            }
        }

        function getEngagementChannels(visitorId) {
            var channels = [];
            if (logicController.participants[visitorId]) {
                for (var item in logicController.participants[visitorId]) {
                    if (logicController.participants[visitorId][item].isEngagementChannel) {
                        channels.push(logicController.participants[visitorId][item]);
                    }
                }
            }
            return channels;
        }

        function getEngagementDependantChannels(visitorId, channelName, onlyActive) {
            var dependencies = [];
            var channels = getEngagementChannels(visitorId);
            for (var i = 0; i < channels.length; i++) {
                if (channels[i].dependencies && channels[i].dependencies.constructor === Array) {
                    for (var j = 0; j < channels[i].dependencies.length; j++) {
                        if (channels[i].dependencies[j] === channelName) {
                            if (onlyActive) {
                                var dChannel = getEngagementChannel(visitorId, channels[i].dependencies[j]);
                                if (dChannel.isActive) {
                                    dependencies.push(channels[i]);
                                }
                            } else {
                                dependencies.push(channels[i]);
                            }
                        }
                    }
                }
            }
            return dependencies;
        }

        logicController.getVisitorLastConversationId = function (visitorId) {
            var lastConversationId, lastConversation;
            lastConversation = _.find(logicController.getModelParam(lpAMSController.MODEL_PATHS.connectionsListModelLocations.data), {consumerId: visitorId});
            if (_.isObject(lastConversation)) {
                lastConversationId = lastConversation.convId;
            }
            return lastConversationId;
        };

        logicController.getConversationIdFromVisitorId = function (visitorId) {
            var convId = "";
            var convIdStartTime = null;
            _.findKey(logicController.getModelParam('chats'), function (val, key) { //go through the chats list
                if (val && val.visitorInfo && val.chatInfo && val.visitorInfo.visitorId == visitorId) { //find this visitor id
                    if (convIdStartTime === null || val.chatInfo.startTime > convIdStartTime) { //compare the times and take the latest
                        convId = key;
                        convIdStartTime = val.chatInfo.startTime;
                    }
                }
            });
            return convId;
        };

        logicController.getChatIdFromVisitorId = function (visitorId) {
            var last = _.last(
                _.filter(model.get('chats'), function (item) {
                    return item && item.visitorInfo && item.visitorInfo.visitorId == visitorId;
                }).sort(
                    chatStartTimeAscendingComparator
                )
            );
            var chatId = '';
            if (last && last.chatInfo && last.chatInfo.chatId) {
                chatId = last.chatInfo.chatId + '';
            }
            return chatId;

            function chatStartTimeAscendingComparator(a, b) {
                var aStartTs = a.chatInfo.startTime;
                var bStartTs = b.chatInfo.startTime;
                if (aStartTs > bStartTs) {
                    return 1;
                }
                if (aStartTs < bStartTs) {
                    return -1;
                }
                return 0;
            }
        };

        logicController.getSkillIdFromVisitorId = function (visitorId) {
            var chatId = logicController.getConversationIdFromVisitorId(visitorId);
            var skillId = logicController.getModelParam('chats.' + chatId + '.chatInfo.skillIds') || 'unSkillChat';
            return skillId;
        };

        logicController.getLatestChatId = function (participantPath) {
            var visitorChatIds = this.getModelParam(participantPath + '.chats');
            var latestChatId = 0;
            var latestChatIdTime = 0;

            for (var chatId in visitorChatIds) {
                var visitorStartTime = this.getModelParam('chats.' + chatId + '.chatInfo.startTime');
                if (visitorStartTime) {
                    visitorStartTime = new Date(visitorStartTime).getTime();
                    if (visitorStartTime > latestChatIdTime) {
                        latestChatId = chatId;
                        latestChatIdTime = visitorStartTime;
                    }
                }
            }
            return latestChatId;
        };

        /**
         * Return the number of agent group
         * @returns {*}
         */
        logicController.getAgentGroupsLength = function () {
            var agentGroupData = agentLEManager.getAgentGroupsData();
            if (agentGroupData && agentGroupData.items) {
                return agentGroupData.items.length;
            }
            return 0;
        };

        /**
         * Return object with agent groups when key is group id and value is the name of the group
         * @returns {*}
         */
        logicController.getAgentGroupsById = function () {
            var agentGroupData = agentLEManager.getAgentGroupsData();
            if (agentGroupData && agentGroupData.items) {
                var obj = agentGroupData.items.reduce(function (total, current) {
                    total[current.id] = current.name;
                    return total;
                }, {});
                return obj;
            }
            return {};
        };

        logicController.hasAgentGroupsColumn = function () {
            // While regular agents can view other conversations (if given the permission), they can only
            // see conversations in their group - so there's still no point in showing the column if it will
            // only show 1 group.
            return privilegesController.hasAgentManagerModulePrivilege() &&
                agentLEManager.hasLiveEngage2Feature() &&
                agentLEManager.hasAgentGroupsFeature() &&
                this.getAgentGroupsLength() > 1;
        };

        logicController.hasVisitorFeedPreFiltering = function () {
            return !logicController.hasVisitorFeedQueryFeature() && agentLEManager.hasVisitorFeedPreFiltering();
        };

        logicController.parseTrueOrFalseStringToBool = function (data) {
            //this function return true only if str === true
            if (typeof data !== 'string') {
                return data;
            }
            return data.toLowerCase() === 'true';

        };

        /**
         * written purely to clear all dots from key segments that are passed into model paths.
         * @type {{unsafeDelimiter: string, safeDelimiter: string, toSafeKeySegment: Function}}
         */
        logicController.modelPatcher = {
            unsafeDelimiter: '.',
            safeDelimiter: '-',
            toSafeKeySegment: function (keSegment) {
                return keSegment && keSegment.replace(logicController.modelPatcher.unsafeDelimiter, logicController.modelPatcher.safeDelimiter);
            }
        };
        /**
         * Format time duration, get the time in milliseconds and return object with text dan tooltip
         * @param time in milliseconds
         * @param allowOverdue if true, allow overdue for SLA use
         * @returns {{text: string, tooltip: string}}
         */
        logicController.getFormatDurationTime = function (time, allowOverdue) {
            var result = {
                text: '',
                tooltip: ''
            };
            // if Time is not a number or duration is negative
            if (typeof time !== 'number' || (time <= 0 && !allowOverdue)) {
                result.text = "...";
                result.tooltip = "...";
                return result;
            }
            if (time === 0 && allowOverdue) {
                result.text = '0m';
                result.tooltip = agentLEManager.translateLE({key: 'LEWebAgent.SLATooltipOverdue'});
                return result;
            }
            // Break down the time to elements
            var breakdown = lpUtils.getTimeBreakdownFromMilliSeconds(Math.abs(time));
            breakdown.days  = Math.floor(breakdown.days);
            breakdown.hours  = Math.floor(breakdown.hours);
            breakdown.minutes  = Math.floor(breakdown.minutes);
            breakdown.seconds  = Math.floor(breakdown.seconds);
            // Calculate rounding
            var rounding = {};
            rounding.days = breakdown.days;
            rounding.hours = breakdown.hours;
            rounding.minutes = breakdown.seconds < 30 ? breakdown.minutes : breakdown.minutes +1;
            // Check for overflow on after rounding minutes and hours
            if (rounding.minutes === 60) {
                rounding.minutes = 0;
                rounding.hours++;
                fixHoursRounding();
            }
            // round the minutes only if displaying on days format
            if (rounding.days > 0 && rounding.minutes > 29) {
                rounding.hours++;
                rounding.minutes = 0;
                fixHoursRounding();
            }

            // time is negative, only if time is less then -30 sec. (after rounding -29s = 0m, 30 = -1)
            rounding.negative = time <= -30000;

            // build the text
            var overdue = time < 0;
            result.text = getText(rounding);
            result.tooltip = getTooltip(breakdown, overdue);

            return result;

            /**
             * Fixing the hours and days if hours roundup to 24
             */
            function fixHoursRounding (){
                if (rounding.hours === 24) {
                    rounding.hours = 0;
                    rounding.days++;
                }
            }
            /**
             * Get the translated text.
             * @param rounding
             * @returns {string}
             */
            function getText(rounding) {
                var translateParam = {key: 'LEWebAgent.SLA', args: []};
                var text = "";
                // Decide format to display
                if (rounding.days > 0) { // format xd yh
                    addToKeyAndArgs(rounding.days, 'days');
                    if (rounding.hours > 0) {
                        addToKeyAndArgs(rounding.hours, 'hours');
                    }
                } else if (rounding.hours > 0) { // format xh ym
                    addToKeyAndArgs(rounding.hours, 'hours');
                    if (rounding.minutes > 0) {
                        addToKeyAndArgs(rounding.minutes, 'minutes');
                    }
                } else { // format xm
                    addToKeyAndArgs(rounding.minutes, 'minutes');
                }

                if (rounding.negative) {
                    text = '-';
                }
                text += agentLEManager.translateLE(translateParam);
                return text;

                /**
                 * Adds a name & value to the key & arguments for the text translation.
                 * @param value The value to be added to the arguments.
                 * @param name The name to be added to the key.
                 */
                function addToKeyAndArgs(value, name) {
                    translateParam.key += '_' + name;
                    translateParam.args.push(Math.abs(value));
                }
            }

            /**
             * Gets the translated tooltip
             * @param breakdown
             * @param overdue
             * @returns {*}
             */
            function getTooltip(breakdown, overdue) {
                var translateParam = {key: 'LEWebAgent.SLATooltip', args: []};
                if (overdue) {
                    translateParam.key += 'Overdue';
                }
                if (breakdown.days > 0) {
                    addToKeyAndArgsAccordingToSize(breakdown.days, 'day');
                }
                if (breakdown.hours > 0) {
                    addToKeyAndArgsAccordingToSize(breakdown.hours, 'hour');
                }
                if (breakdown.minutes > 0) {
                    addToKeyAndArgsAccordingToSize(breakdown.minutes, 'minute');
                }
                if (breakdown.seconds > 0) {
                    addToKeyAndArgsAccordingToSize(breakdown.seconds, 'second');
                }

                var callWith = translateParam.key;
                if (translateParam.args.length > 0) {
                    callWith = translateParam;
                }
                return agentLEManager.translateLE(callWith);

                /**
                 * Adds a name & value to the key & arguments for the tooltip translation, according to the value:
                 * We only add non-zero values, and we take into account if value is a single or multiple value.
                 * @param value The value to be added to the arguments (if needed)
                 * @param name The name to be added to the key (if the value is non-zero)
                 */
                function addToKeyAndArgsAccordingToSize(value, name) {
                    if (value >= 1 || value <= -1) {
                        translateParam.key += '_' + name;
                    }
                    if (value > 1 || value < -1) {
                        translateParam.key += 's';
                        translateParam.args.push(Math.abs(value));
                    }
                }
            }
        };

        // TODO: Remove from here to the AMSSubscriptionManager class. (and fix tests)
        /**
         * Calculates and returns the SLA texts (text & tooltip) according to the future TTR, based on the current time.
         * @param time The future TTR in milliseconds.
         * @param timeDiff The difference between local time and the time in the server
         * @returns {{text: string, tooltip: string}}
         */
        logicController.getSLATextFromTimestamp = function (time, timeDiff) {
            var result = {
                text: '',
                tooltip: '',
                almostOverdue: false
            };
            if (typeof time !== 'number' || time === -1) {
                return result;
            }
            var now = lpTag.WebAgent.logicController.getCurrentTimeWithDiff(timeDiff);
            result = lpTag.WebAgent.logicController.getFormatDurationTime(time - now, true);
            // if time <= 5 min set almostOverdue;
            result.almostOverdue = (time <= 300000) ? true : false;

            return result;
        };

        /**
         * will return the normalize path for the chats model path, remove the last '.' if exists.
         * @param path
         */
        function getChatsRoomModelPath(path) {
            if (path) {
                if (path[path.length - 1] === '.') {
                    return path.slice(0, path.length - 1);
                }
                return path;
            }

            return logicController.defaultChatsRootModelPath;
        }

        logicController.getAcUsersAgentIdFromMessagingUserId = function(messagingUserId) {
            if (!messagingUserId) {
                return;
            }

            var dotIndex = messagingUserId.indexOf('.');
            if(dotIndex === -1){
                return;
            }

            return messagingUserId.substr(dotIndex+1);
        };


        logicController.getChatSkillIds = function (chatId) {
            var agentSkillIds, engagementSkillIds;

            if (!chatId) {
                return;
            }

            agentSkillIds = logicController.getAgentSkillIdsByChatId(chatId);
            engagementSkillIds = logicController.getEngagementSkillIdsByChatId(chatId);

            if (!agentSkillIds.length && !engagementSkillIds.length) {
                return [];
            }
            if (_.intersection(agentSkillIds, engagementSkillIds).length) {
                return engagementSkillIds;
            }
            return agentSkillIds;
        };

        logicController.getOperatorInfo = function(agentId){
            if(agentId + "" === this.getModelParam('operators.loggedInUser.id' + "")) {
                return this.getModelParam('operators.loggedInUser');
            }
            return this.getModelParam('operators.data.' + agentId);
        };

        logicController.getAgentSkillIdsByChatId = function (chatId, chatsRootModelPath) {
            chatsRootModelPath = getChatsRoomModelPath(chatsRootModelPath);

            var agentSkillIds = [];
            var assignedAgentId = model.get(chatsRootModelPath + '.' + chatId + '.agentInfo.agentId');
            var operator = logicController.getOperatorInfo(assignedAgentId);
            if(operator){
                agentSkillIds = operator.skillIds;
            }
            return logicController.toStringTypedArray(agentSkillIds);
        };

        logicController.getEngagementSkillIdsByChatId = function (chatId, chatsRootModelPath) {
            chatsRootModelPath = getChatsRoomModelPath(chatsRootModelPath);

            var storedEngagementSkillIds, engagementSkillIds;
            storedEngagementSkillIds = model.get(chatsRootModelPath + '.' + chatId + '.chatInfo.skillIds');
            engagementSkillIds = logicController.ensureArray(storedEngagementSkillIds);
            engagementSkillIds = logicController.toStringTypedArray(engagementSkillIds);
            return engagementSkillIds;
        };

        logicController.ensureArray = function (value) {
            if (!value) {
                return [];
            }
            if (!_.isArray(value)) {
                return [value];
            }
            return value;
        };

        logicController.toStringTypedArray = function (arr) {
            return _.map(arr, String);
        };

        logicController.toNumberTypedArray = function(arr) {
            return _.map(logicController.ensureArray(arr), Number);
        };

        logicController.getEnvironment = function(){
            // todo - get 'environment' from a proper config module, not from the global namespacereturn window.leConfiguration.environment;
        };

        logicController.isDevEnvironment = function(){
            return leConf.environment === window.LE.CONST.ENVIRONMENTS.DEV;
        };

        /**
         * get site settings for ring timeout
         * @returns {Number|null}
         */
        logicController.getRingTimeoutSettings = function() {
            var settings = agentLEManager.getAccountSettingValueByIdLE('le.agent.messagingAcceptButtonTimeout');
            if(_.isNumber(settings)) {
                return settings * 1000;
            }
            return null;
        };

        /**
         * Gets the photoSize value from site settings. Default/minimum is 800 pixels.
         * @returns {*}
         */
        logicController.getImageResize = function() {
            var minimumValue = 800;
            var value = agentLEManager.getAccountSettingValueByIdLE('messaging.agent.photo.size');
            if(_.isNumber(value) && value >= minimumValue) {
                return value;
            }
            return minimumValue;
        };

        logicController.isAgentFileSharingEnabled = function() {
            var value = agentLEManager.getAccountSettingValueByIdLE('messaging.agent.file.sharing.enabled');
            return !!value && value === 'true';
        };

        logicController.canConsumerReceiveFiles = function(chatId) {
            var features = model.get('chats.' + chatId + '.chatInfo.features');
            var integration = model.get('chats.' + chatId + '.chatInfo.integration');
            return !!features && (!!features.FILE_SHARING || (!!features.PHOTO_SHARING && !!integration && integration !== 'MOBILE_SDK'));
        };

        logicController.canSendFileFromLocalFileSystem = function(chatId) {
            return this.isEngagementAsyncMessaging(chatId) && this.isAgentFileSharingEnabled() && privilegesController.hasSendFilesFromLocalFileSystemPrivilege();
        };

        logicController.canSendFileFromCustomWidget = function(chatId) {
            return this.isEngagementAsyncMessaging(chatId) && this.getChatStateByChatId(chatId, 'chats') === this.chatStates.chatting && this.isAgentFileSharingEnabled() && privilegesController.hasSendFilesFromCustomWidgetPrivilege();
        };

        logicController.canConsumerReceiveFileFromLocalFileSystem = function(chatId) {
            return this.canSendFileFromLocalFileSystem(chatId) && this.canConsumerReceiveFiles(chatId);
        };

        logicController.canConsumerReceiveFileFromCustomWidget = function(chatId) {
            return this.canSendFileFromCustomWidget(chatId) && this.canConsumerReceiveFiles(chatId);
        };

        logicController.getPredefinedContentMacroContext = function(chatId) {
            var chatsRootModelPath = logicController.defaultChatsRootModelPath;
            var agent = model.get('agent') || {};
            var skillId = model.get(chatsRootModelPath + '.' + chatId + '.chatInfo.skillIds') || -1;
            var skill = model.get('skills.data.' + skillId) || {};
            var visitor = model.get(chatsRootModelPath + '.' + chatId + '.visitorInfo') || -1;
            return { agent: agent, skill: skill, visitor: visitor };
        };

        logicController.getAgentMessagingTransferToAgentPermissions = function () {
            if (!!agentLEManager.getFeatureProperty("Messaging.Transfer_To_Agent")) {
                var res = {};
                res.offline = !!privilegesController.hasTransferMessagingConversationToOffline();
                res.away = !!privilegesController.hasTransferMessagingConversationToAway();
                res.online = res.back_soon = !!privilegesController.hasTransferMessagingConversationToOnlineAndBackSoon();
                return _.some(res, Boolean) && res;
            }

            return false;
        };

        logicController.hasTransferToAgentFeatureEnabled = function () {
            return !!agentLEManager.getFeatureProperty("Messaging.Transfer_To_Agent");
        };

        logicController.getAgentStatusReasonById = function (statusReasonId) {
            var agentStatusReasons = LE.crossModule("dataModule", LE.media.actions.request, LE.mediaCodes.dataModule.reqres.getAgentReasonsCollection);

            return agentStatusReasons.getTextById(statusReasonId);
        };

        logicController.getAgentPidFromAgentId = function (agentId) {
            return model.get('operators.data.' + agentId + '.pid');
        };

        return logicController;
    };

    return lpTag.lpLogicController;

});
